import { render } from "./ActCard.vue?vue&type=template&id=8a4577be&scoped=true"
import script from "./ActCard.vue?vue&type=script&lang=js"
export * from "./ActCard.vue?vue&type=script&lang=js"

import "./ActCard.vue?vue&type=style&index=0&id=8a4577be&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4577be"]])

export default __exports__